import { SVGProps } from 'react';

/** Half-filled circle for the Appearance settings group. */
export const ContrastIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg data-icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={1.75} />
    <path d="M12 3.875a8.125 8.125 0 0 1 0 16.25V3.875Z" fill="currentColor" />
  </svg>
);
